import {AuthApiService} from '../services/AuthApiService'


const syncLogoutWithOtherTabs = ()=>{
  localStorage.setItem('setLogout', 'logout');
  localStorage.removeItem('setLogout', 'logout');
}
const setShareLoginFlagCookie = (flag)=>{
  var date = new Date();
  date.setTime(date.getTime() + (8 * 60 * 60 * 1000));
  var expires = "; expires=" + date.toGMTString();
  document.cookie = "share_dev_login_flag" + "=" + flag + expires + "; path=/; domain=" + ".fdnycloud.org";
}
const isShareLogin = ()=>{
  var parseCookies = str =>
  str
  .split(';')
  .map(v => v.split('='))
  .reduce((acc, v) => {
    acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
    return acc;
  }, {});
  var cookies_obj = parseCookies(document.cookie);
  return cookies_obj.share_dev_login_flag ? cookies_obj.share_dev_login_flag==='Y' : false;
}
const logout = async () => {
    const _authApiService = new AuthApiService();


    //if it's share login that mean admin access has login on one of the tab.
    if(isShareLogin()){
        console.log('call admin logout when sahre_login_flag is Y');
        sessionStorage.setItem('login_flag', 'N');
   
        setShareLoginFlagCookie('N')
        const sessionResponse = await _authApiService.getIdcsSessionId();
        const sessionIdValue = sessionResponse.idcssessionId;
        const hostUrl = window.location.protocol+'//'+window.location.host;
    
        window.setTimeout(() => {
          syncLogoutWithOtherTabs()
          //window.location.href = hostUrl + `/accountmanagement/oauthadmin/logout?session-id=${sessionIdValue}`;
          window.location.href = hostUrl + `/accountmanagement/webapi/logout`;
        }, 1000);
        return 
    }


    if(sessionStorage.getItem('login_flag') !== 'Y') {
      sessionStorage.setItem('login_flag', 'N');
      const hostUrl = window.location.protocol+'//'+window.location.host;
      //const sessionResponse = await _authApiService.getSessionId();
      //const sessionId = sessionResponse.sessionId;
      syncLogoutWithOtherTabs()
      //window.location.href = hostUrl + `/accountmanagement/oauth/logout?session-id=${sessionId}`;
      window.location.href = hostUrl + `/accountmanagement/webapi/logout`;
    
    } else {
      console.log('two logout');
      sessionStorage.setItem('login_flag', 'N');
      const sessionResponse = await _authApiService.getIdcsSessionId();
      const sessionIdValue = sessionResponse.idcssessionId;
      console.log(sessionIdValue);
      const hostUrl = window.location.protocol+'//'+window.location.host;
      window.setTimeout(() => {
        syncLogoutWithOtherTabs()
        //window.location.href = hostUrl + `/accountmanagement/oauthadmin/logout?session-id=${sessionIdValue}`;
        window.location.href = hostUrl + `/accountmanagement/webapi/logout`;
      }, 1000);
      
    }
  }

  const refreshAccessToken = async ()=>{
    // const _authApiService = new AuthApiService();
    // const sessionResponse = await _authApiService.getSessionId();
    // const sessionId = sessionResponse.sessionId;
    // if(sessionId){
    // await _authApiService.refreshAccessToken(sessionId)
    // }
    // const idcsSessionResponse = await _authApiService.getIdcsSessionId();
    // const idcsSessionId = idcsSessionResponse.idcssessionId;
    // if(idcsSessionId){
    // await _authApiService.refreshIDCSAccessToken(idcsSessionId)
    // }

  }

  export default {
    logout,
    refreshAccessToken,
    setShareLoginFlagCookie
  }